import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './theme.css';
import App from './App';
import './i18n';
import { debugLog } from './utils/logger';
import hideIubendaBannerIfConsentGiven from './utils/iubendaBannerManager';

// Controllo dell'ambiente per il debug
if (process.env.NODE_ENV === 'development') {
    debugLog('⚡ Modalità sviluppo attivata!');
}

// Gestisce la visibilità del banner cookie Iubenda
// Nasconde il banner dopo che l'utente ha dato il consenso
hideIubendaBannerIfConsentGiven();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>
);
